class HimalayanDraftCards extends HTMLElement {
  #observer;

  connectedCallback() {
    if (location.hostname !== '127.0.0.1' || location.port !== '9292') return;
    this.#observer?.disconnect();
    this.#observer = new MutationObserver(() => this.#connectCards());
    this.#observer.observe(this, { childList: true, subtree: true });
    this.#connectCards();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #connectCards() {
    for (const card of this.querySelectorAll('.himalayan-catalogue-card')) {
      if (card.matches('a') || card.querySelector('a')) continue;
      const source = card.querySelector('img')?.getAttribute('src') || '';
      const sku = source.match(/himalayan-((?:jptk|xtk|tk|sp)-\d{3})(?:\.|_)/i)?.[1];
      if (!sku) continue;
      const link = document.createElement('a');
      link.className = 'himalayan-product-card__link himalayan-draft-preview-link';
      link.href = 'http://127.0.0.1:9293/products/' + sku.toUpperCase();
      link.append(...card.childNodes);
      card.append(link);
    }
  }
}

if (!customElements.get('himalayan-draft-cards')) customElements.define('himalayan-draft-cards', HimalayanDraftCards);
